import { Routes } from '@angular/router';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { AuthGuard } from './core/services/guard/auth.guard';
import { pageAssemblyResolver } from './features/page-assemblies/main-page-assembly/page-assembly.resolver';
import { homeResolver } from './features/home/home.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/home/home.component').then((m) => m.HomeComponent),
    resolve: { home: homeResolver },
  },
  {
    path: ':slug',
    loadComponent: () =>
      import(
        './features/page-assemblies/main-page-assembly/main-page-assembly.component'
      ).then((m) => m.MainPageAssemblyComponent),
    resolve: { page: pageAssemblyResolver },
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  {
    path: ':slug/:nested',
    loadComponent: () =>
      import(
        './features/page-assemblies/main-page-assembly/main-page-assembly.component'
      ).then((m) => m.MainPageAssemblyComponent),
    resolve: { page: pageAssemblyResolver },
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  { path: '**', component: NotFoundComponent },
];
